import React from 'react';
import { Menu, MenuTrigger, MenuList, MenuItem, MenuPopover } from '@fluentui/react-components';
import styles from './PulseModal.module.css';

const PulseNavIcon = () => (
    <svg className={styles.pulseNavIcon} viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path
            d="M1 9.5H3.2L5.1 3.5L8.4 15.5L11.2 6.5L13.1 9.5H19"
            stroke="white"
            strokeWidth="1.75"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

const PulseNavMenu = ({ showUserPulse, showWorkspacePulse, onUserPulse, onWorkspacePulse }) => {
    if (!showUserPulse && !showWorkspacePulse) {
        return null;
    }

    return (
        <Menu>
            <MenuTrigger disableButtonEnhancement>
                <button type="button" className={styles.pulseNavBtn} aria-label="Lens Pulse" title="Lens Pulse">
                    <PulseNavIcon />
                </button>
            </MenuTrigger>
            <MenuPopover>
                <MenuList>
                    {showUserPulse ? <MenuItem onClick={onUserPulse}>User Pulse</MenuItem> : null}
                    {showWorkspacePulse ? <MenuItem onClick={onWorkspacePulse}>Workspace Pulse</MenuItem> : null}
                </MenuList>
            </MenuPopover>
        </Menu>
    );
};

export default PulseNavMenu;
